import { gql } from '@apollo/client';
import InspectionFields from 'queries/inspection/inspection_fields_fragment';

export default gql`
  query inspection($id: ID!) {
    space {
      adminRole
      inspectorRole
    }
    inspection(id: $id) {
      ...InspectionFields
      notes
      complianceRatio
      inspector {
        id
        name
        surname
        email
      }
      inspectionFields {
        id
        name
        order
        templateFieldId
      }
      place {
        id
        name
        street
        city
        zipCode
      }
      inspectionSubject {
        id
        name
        serialNumber
        brand
        model
        place {
          id
        }
      }
    }
  }
  ${InspectionFields}
`;
